import { supabaseServer } from '@/lib/supabase.server';
import { queryOptions, type QueryClient } from '@tanstack/react-query';
import { Link, createFileRoute, redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import AdminLayout from '../components/AdminLayout';

export const fetchUser = createServerFn({ method: 'GET' }).handler(async () => {
  const supabase = supabaseServer();
  const { data } = await supabase.auth.getUser()

  if (!data.user?.email) {
    return null
  }

  return {
    email: data.user.email,
    user_metadata: data.user.user_metadata,
  }
})

// Gecachet zodat niet elke tabwissel in admin eerst via de server gaat.
// De echte autorisatie zit in RLS; dit bepaalt alleen de redirect.
const authUserQueryOptions = () =>
  queryOptions({
    queryKey: ['auth-user'],
    queryFn: () => fetchUser(),
    staleTime: 1000 * 60 * 5,
  });

/** Gooi de gecachte user weg na in- of uitloggen of een profielwijziging. */
export function resetAuthUser(queryClient: QueryClient) {
  queryClient.removeQueries({ queryKey: authUserQueryOptions().queryKey });
}

export const Route = createFileRoute('/admin')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData({
      ...authUserQueryOptions(),
      revalidateIfStale: true,
    });

    if (!user) {
      // Geen null cachen, anders blijft na inloggen de redirect hangen
      resetAuthUser(queryClient);
      throw redirect({ to: '/sign-in' });
    }

    return {
      user,
    }
  },
  component: AdminLayoutWrapper,
  // Binnen /admin blijft de 404 in de admin-stijl; de root-404 is voor publiek.
  notFoundComponent: AdminNotFound,
});

function AdminNotFound() {
  return (
    <div className="py-12 flex flex-col items-center justify-center">
      <h1 className="text-4xl font-extrabold text-gray-900">404</h1>
      <p className="mt-2 text-gray-500">Pagina niet gevonden</p>
      <Link to="/admin" className="mt-4 text-primary hover:text-primary-600 underline">
        Terug naar admin
      </Link>
    </div>
  );
}

function AdminLayoutWrapper({}) {

  return <AdminLayout />;
}
